import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                border: "1px solid #DDD9D1",
                color: "#0F0F0F",
                borderRadius: "2px",
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
